// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610061236/js/" + chunkId + "." + {"44":"920007be","225":"c6b4feef","481":"2e0c748d","486":"62a0311b","770":"fb80ff5e"}[chunkId] + ".0.49132856714366546.chunk.js";
};